export type DecisionMaker = {
	id: string;
	displayName: string;
	slug: string;
	title: string | null; // pt.summary is set to o.name ("Tucson City Council - Ward 4")
	location: string; // "Tucson, AZ"
	photoUrl: string | null;
	signersText: string; // "Represents 2,432 petition signers" // associationData.constituentCountAmongSignersLocalized
	publiclyVisible: boolean;
	response?: string;
};

export type LegislativeBody = {
	title: string; // "City Council"
	location: string; // "Tucson, AZ"
	signersText: string;
	displayedDMs: readonly DecisionMaker[];
	displayViewMoreButton: boolean;
};

type Result = ModelHookResult<{
	primaryDM: DecisionMaker;
	legislativeBodies: LegislativeBody[];
	displayViewAllButton: boolean;
}>;

const DISPLAYED_DM_COUNT = 2;

// eslint-disable-next-line max-lines-per-function
export function useDecisionMakers(): Result {
	// TODO https://change.atlassian.net/browse/CHANGE-77354
	// Get data below from API and shape signersText here
	const primaryDM = {
		id: '1',
		displayName: 'Regina Romero',
		slug: 'example.com',
		title: 'Tucson City Mayor',
		location: 'Tucson, AZ',
		photoUrl: null,
		signersText: 'Represents 2,432 petition signers',
		publiclyVisible: false,
	};

	const legislativeBodies = [
		{
			title: 'City Council',
			location: 'Tucson, AZ',
			signersText: '8 members representing 2,132 signers',
			decisionMakers: [
				{
					id: '2',
					displayName: 'Nikki Lee',
					slug: 'example.com',
					title: 'Tucson City Council - Ward 4',
					location: 'Tucson, AZ',
					photoUrl: null,
					signersText: 'Represents 815 petition signers',
					publiclyVisible: false,
					response:
						'Thank you to everyone who has signed the petition, shared it with others, and sent thoughtful comments and emails regarding Project Blue. Your engagement and feedback matter.',
				},
				{
					id: '3',
					displayName: 'Lane Santa Cruz',
					slug: 'example.com',
					title: 'Tucson City Council - Ward 1',
					location: 'Tucson, AZ',
					photoUrl: null,
					signersText: 'Represents 262 petition signers',
					publiclyVisible: false,
				},
				{
					id: '4',
					displayName: 'Paul Cunningham',
					slug: 'example.com',
					title: 'Tucson City Council - Ward 2',
					location: 'Tucson, AZ',
					photoUrl: null,
					signersText: 'Represents 24 petition signers',
					publiclyVisible: false,
				},
				{
					id: '5',
					displayName: 'Kevin Dahl',
					slug: 'example.com',
					title: 'Tucson City Council - Ward 3',
					location: 'Tucson, AZ',
					photoUrl: null,
					signersText: 'Represents 12 petition signers',
					publiclyVisible: false,
				},
				{
					id: '6',
					displayName: 'Rocque Perez',
					slug: 'example.com',
					title: 'Tucson City Council - Ward 5',
					location: 'Tucson, AZ',
					photoUrl: null,
					signersText: '',
					publiclyVisible: false,
				},
			],
		},
	];

	return {
		data: {
			primaryDM,
			legislativeBodies: legislativeBodies.map(({ decisionMakers, ...rest }) => ({
				...rest,
				displayedDMs: decisionMakers.slice(0, DISPLAYED_DM_COUNT),
				displayViewMoreButton: decisionMakers.length > DISPLAYED_DM_COUNT,
			})),
			displayViewAllButton: true,
		},
	};
}
